module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-mobile-img3-b126897be2a29e635b424062b7df50d5.jpg";